import script from "./AuthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=ts"

import "./AuthView.vue?vue&type=style&index=0&id=517c1d83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517c1d83"]])

export default __exports__